import { combineReducers } from 'redux';
import cookies from 'tradera-apps/my-tradera/app/state/reducers/cookies';
import filters from 'tradera-apps/my-tradera/app/state/reducers/filters';
import myTradera from 'tradera-apps/my-tradera/app/state/reducers/my-tradera';
import myTraderaItems from 'tradera-apps/my-tradera/app/state/reducers/my-tradera-items';
import payments from 'tradera-apps/my-tradera/app/state/reducers/payments-reducer';
import payout from 'tradera-apps/my-tradera/app/state/payouts/reducer';
import purchaseOrder from 'tradera-apps/my-tradera/app/state/reducers/purchase-order';

export default combineReducers({
    cookies,
    filters,
    myTradera,
    myTraderaItems,
    payments,
    payout,
    purchaseOrder
});
